export default "__VITE_ASSET__BDNmYRBd__"